import type { ReportLayoutConfig, SectionBuild } from '@/features/reports'

// v3 `configs/MarketingInsights/LandingPage.js` (39 ln). Straight port: one Overview section
// with channel-rail tabs (logos render from `name`), `visibleType: 'double'` → chart-table
// composition,
// and `partition_only: !!tab.channel` (Overall merges partitions, channel tabs stay
// partition-only). v3's id template stringified the Overall tab's undefined channel
// ('22-overview-undefined') — kept verbatim as the persistence id.

const LANDING_PAGE_REPORT_ID = 22

const landingPageBuild: SectionBuild = ({ tab }) => ({
  id: `22-overview-${tab.channel}`,
  reportId: LANDING_PAGE_REPORT_ID,
  scheduleTabs: tab.tabs ?? [],
  partitionOnly: !!tab.channel,
  view: 'table',
  composition: 'chart-table',
  allowedViews: ['table', 'chart'],
})

export const LANDING_PAGE: ReportLayoutConfig = [
  {
    name: 'Overview',
    labelKey: 'marketingInsights.landingPage.tabs.overview',
    sections: [
      {
        id: '22-overview',
        titleKey: 'marketingInsights.landingPage.overview.title',
        reportId: LANDING_PAGE_REPORT_ID,
        showDatePicker: true,
        tabs: [
          {
            name: 'Overall',
            labelKey: 'marketingInsights.landingPage.channels.overall',
            reportId: LANDING_PAGE_REPORT_ID,
            tabs: ['overview'],
          },
          {
            name: 'GA4',
            labelKey: 'marketingInsights.landingPage.channels.ga4',
            channel: 'ga4',
            reportId: LANDING_PAGE_REPORT_ID,
            tabs: ['metrics_mp_landingpage'],
          },
          {
            name: 'Search Console',
            labelKey: 'marketingInsights.landingPage.channels.searchConsole',
            channel: 'search_console',
            reportId: LANDING_PAGE_REPORT_ID,
            tabs: ['metrics_organic_landingpage'],
          },
          {
            name: 'Google Ads',
            labelKey: 'marketingInsights.landingPage.channels.googleAds',
            channel: 'google_ads',
            reportId: LANDING_PAGE_REPORT_ID,
            tabs: ['google_ads_landingpage'],
          },
          {
            name: 'Hardal',
            labelKey: 'marketingInsights.landingPage.channels.hardal',
            channel: 'hardal',
            reportId: LANDING_PAGE_REPORT_ID,
            tabs: ['metrics_hardal_landingpage'],
          },
        ],
        build: landingPageBuild,
      },
    ],
  },
]
